import { ArrayUtils } from './ArrayUtils'
import {
    $LocalStorage,
    deleteAllNonEssentialCookies,
    deleteCookie,
    getCookiesAsArray,
    LocalStorageSetterOptions
} from './StorageUtils'
import COOKIE_CONSENT from '../../../conf/CookiesConsentConfig.json'
import { IsVarEmpty } from './GlobalFunctions'

const COOKIE_CONSENT_NAME = 'cookie-consent'

const STANDARD_LS_OPTIONS: LocalStorageSetterOptions = {
    daysToLive: COOKIE_CONSENT.ttl,
    version: COOKIE_CONSENT.version
}

export const getCookieConsent = (): Nullable<string[]> =>
    $LocalStorage.getItem(COOKIE_CONSENT_NAME, COOKIE_CONSENT.version) ?? null
export const hasCookieConsentSetting = (): boolean => !IsVarEmpty(getCookieConsent())
export const hasCookieConsent = (consent: string): boolean => !!~(getCookieConsent()?.indexOf(consent) ?? -1) ?? false
export const setCookieConsent = (consent: string[]): void =>
    $LocalStorage.setItem(COOKIE_CONSENT_NAME, consent, STANDARD_LS_OPTIONS)
export const deleteCookieConsent = (): void => $LocalStorage.removeItem(COOKIE_CONSENT_NAME)
export const addCookieConsent = (...consents: string[]): void =>
    $LocalStorage.setItem(
        COOKIE_CONSENT_NAME,
        ArrayUtils.removeDuplicates([...(getCookieConsent() ?? []), ...consents]),
        STANDARD_LS_OPTIONS
    )
export const removeCookieConsent = (...consents: string[]): void =>
    $LocalStorage.setItem(
        COOKIE_CONSENT_NAME,
        (getCookieConsent() ?? []).filter((cookie: string) => !consents.includes(cookie)),
        STANDARD_LS_OPTIONS
    )
export const isCookieAllowed = (cookieName: string): boolean =>
    [...(getCookieConsent() ?? []), ...COOKIE_CONSENT.essential].some((allowedCookie: string): boolean =>
        new RegExp(allowedCookie, 'g').test(cookieName)
    )
export const deleteAllUnacceptedCookies = (): void => {
    const allowedCookies: string[] = getCookieConsent() ?? []

    if (allowedCookies.length === 0) {
        deleteAllNonEssentialCookies()
    } else {
        const cookies: string[][] = getCookiesAsArray()

        cookies.forEach(([cookieName]: string[]): void => {
            if (!isCookieAllowed(cookieName)) {
                deleteCookie(cookieName)
            }
        })
    }
}
